import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { RoleType } from 'bluetail-globals';
import axiosApis from '../../common/apis/axiosApis';

export type AddAccountUserParams = {
    aircraft_assignment_method: 'fleet' | 'all' | 'aircraft';
    fleets: number[] | null;
    aircrafts: number[] | null;
    company_id: number;
    first_name: string;
    last_name: string;
    email: string;
    marketing_user_type: string;
    login_expiry: string | null;
    role_id: RoleType;
};

type AddUserResponse = {
    message: string;
};

export async function addAccountUser(params: AddAccountUserParams): Promise< AxiosResponse<AddUserResponse>> {
  const userDetails = JSON.parse(localStorage.getItem('adminDetails')) as {token: string;};

  return axiosApis.post('/admin/addUser', params, {
    headers: {
      Authorization: userDetails.token,
      'Content-Type': 'application/json',
    },
  });
}

function useAddAccountUserMutation(): UseMutationResult<AxiosResponse<AddUserResponse>, Error, AddAccountUserParams, unknown> {
  return useMutation({
    mutationFn: addAccountUser,
  });
}

export default useAddAccountUserMutation;
